<!-- version 2021/05/20 -->
<template>
    <a v-if='blank' class='btn' :href='link' target='_blank'>{{ title }}</a>
    <a v-else class='btn' :href='link'>{{ title }}</a>
</template>

<script>
    export default {
        props: {
            title: String,
            link: String,
            target: String
        },
        data() {
            return {
                blank: this.target == '_blank'
            }
        }
    }
</script>

<style lang="sass" scoped>
    a
        background: #28C3CD
        border-radius: 3rem
        box-shadow: 0 2px 0 #1A868D
        box-sizing: border-box
        color: #FFF
        display: block
        font-size: 1.25rem
        font-weight: normal
        height: 100%
        line-height: 1
        max-width: 500px
        padding: 20px
        text-align: center
        text-decoration: none
        width: 100%
        -webkit-box-shadow: 0 2px 0 #1A868D
        -webkit-box-sizing: border-box
    a:focus
        box-shadow: 0 2px 0 #1A868D
        -webkit-box-shadow: 0 2px 0 #1A868D
    a:hover
        background: #28C3CD !important
</style>
